import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/**
 * ScrollToTopFab — an understated circular button that appears after the user
 * scrolls past ~40% of the viewport height. Tucked into the bottom-left so it
 * doesn't collide with the floating WhatsApp CTA on the right.
 */
export default function ScrollToTopFab() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > Math.max(300, window.innerHeight * 0.4));
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      data-testid="scroll-top-fab"
      aria-label="Back to top"
      onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "smooth" })}
      className={`fixed bottom-5 left-5 z-40 rounded-full border border-forest/15 bg-parchment/85 p-2.5 text-forest shadow-soft backdrop-blur transition-all hover:bg-parchment ${
        visible ? "opacity-100 translate-y-0" : "pointer-events-none opacity-0 translate-y-3"
      }`}
    >
      <ArrowUp size={16} />
    </button>
  );
}
